<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UTWGeZ/tc-custom/9781623808822.jpg?1718183001158" alt="This image is the cover for the book De la A a la Z, La saga de la ciudad de Coda"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">De la A a la Z, La saga de la ciudad de Coda
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Un libro de La saga de la ciudad de Coda</i></b></p><p>Zach Mitchell está preso en la rutina. Su novio de la universidad lo dejó hace diez años, pero él aún vive en el mismo apartamento, conduce el mismo coche y alimenta al desagradecido gato de su ex novio. Su negocio en Denver, el videoclub De la A a la Z, está en apuros. Tiene clientes molestos, excéntricos vecinos, y un romance vacío con su casero, Tom.</p> <p>Angelo Green, es un tipo duro resentido que lleva botas de combate y se ha criado en casas de acogida. Está solo desde los dieciséis años, por eso nunca aprendió a confiar ni a querer a nadie. No tiene amigos, así que cuando consigue un trabajo en el videoclub De la A a la Z, decide que Zach está estrictamente prohibido.</p> <p>A pesar de sus diferencias, Zach y Angelo se hacen amigos rápidamente por lo que cuando Zach rompe con Tom y la estabilidad de su negocio se tambalea, es a Angelo a quien se le ocurre una solución. Junto a Jared y Matt, sus amigos de Coda, Colorado, Zach y Angelo encontrarán una forma de salvar De la A a la Z, ¿pero serán también capaces de salvarse el uno al otro?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Sexton, Cristina P. Pérez
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cbf2148e